import type { RouteObject } from "react-router";

import AuthLayout from "@/modules/auth-layout";
import LoginPage from "@/modules/login-page";
import PageError from "@/modules/page-error";

import { AuthRouteWrapper } from "./router-auth-routes.component";

export const AUTH_ROUTES: RouteObject[] = [
  {
    path: "auth",
    element: <AuthLayout />,
    children: [
      {
        path: "login",
        element: (
          <AuthRouteWrapper>
            <LoginPage />
          </AuthRouteWrapper>
        ),
      },
      {
        path: "*",
        element: (
          <AuthRouteWrapper>
            <PageError status={404} isAuth />
          </AuthRouteWrapper>
        ),
      },
    ],
  },
];
